/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGenerateSocialVersionMutationRequest, ContentGenerateSocialVersionMutationResponse, ContentGenerateSocialVersionPathParams } from "../models/ContentGenerateSocialVersion";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { contentGenerateSocialVersion } from "../axios/contentGenerateSocialVersion";
import { useMutation } from "@tanstack/react-query";

export const contentGenerateSocialVersionMutationKey = () => ["content-ai-api", { url: '/contents/:id/social-version/:platform/generate' }] as const

export type ContentGenerateSocialVersionMutationKey = ReturnType<typeof contentGenerateSocialVersionMutationKey>

/**
 * @summary Generate adapted version of the content for the target platform
 * {@link /contents/:id/social-version/:platform/generate}
 */
export function useContentGenerateSocialVersion<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentGenerateSocialVersionMutationResponse, ResponseErrorConfig<Error>, {id: ContentGenerateSocialVersionPathParams["id"], platform: ContentGenerateSocialVersionPathParams["platform"], data?: ContentGenerateSocialVersionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentGenerateSocialVersionMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? contentGenerateSocialVersionMutationKey()

  return useMutation<ContentGenerateSocialVersionMutationResponse, ResponseErrorConfig<Error>, {id: ContentGenerateSocialVersionPathParams["id"], platform: ContentGenerateSocialVersionPathParams["platform"], data?: ContentGenerateSocialVersionMutationRequest}, TContext>({
    mutationFn: async({ id, platform, data }) => {
      return contentGenerateSocialVersion(id, platform, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}